import { Component, computed, input } from '@angular/core';
import { AvatarSize } from '../avatar.types';

@Component({
  selector: 'ntt-avatar-online-indicator',
  template: '',
  host: {
    '[class]': 'classes()',
  },
  styles: `
    :host {
      display: block;
      position: absolute;
      box-sizing: content-box;
      border-radius: var(--radius-full, 50rem);
      border: 1.5px solid var(--bg-primary, white);
      overflow: clip;
    }

    :host(.ntt-avatar-online-indicator--online) {
      background-color: var(--fg-success-secondary, #17b26a);
    }

    :host(.ntt-avatar-online-indicator--offline) {
      background-color: var(--fg-disabled-subtle, #d5d7da);
    }

    :host(.ntt-avatar-online-indicator--xs) {
      width: 6px;
      height: 6px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-online-indicator--sm) {
      width: 8px;
      height: 8px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-online-indicator--md) {
      width: 10px;
      height: 10px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-online-indicator--lg) {
      width: 12px;
      height: 12px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-online-indicator--xl) {
      width: 14px;
      height: 14px;
      bottom: 0;
      right: 0;
    }

    :host(.ntt-avatar-online-indicator--2xl) {
      width: 16px;
      height: 16px;
      bottom: 0;
      right: 0;
    }
  `,
})
export class NttAvatarOnlineIndicator {
  readonly size = input<AvatarSize>('md');
  readonly online = input<boolean>(false);

  protected readonly classes = computed(() => {
    const status = this.online() ? 'online' : 'offline';
    return `ntt-avatar-online-indicator ntt-avatar-online-indicator--${this.size()} ntt-avatar-online-indicator--${status}`;
  });
}
